[{"id":"sparks","name":"Brand A","themeColor":"#ff4e07"},{"id":"wu-alumni","name":"Brand B","themeColor":"#007396"}]